import React, { useState, useEffect } from "react";
import AllEvents from "../AllEvents";
import axios from 'axios';
import { G_API, PAGE_LIMIT } from '../../constants/globalVar';
import PageSlider from '../PageSlider';

const EventPage = () => {
    const [items, setItems] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [loadingItem, setLoadingItem] = useState(true);

    const fetchEvents = async (page = 1) => {
        setLoadingItem(false);
        axios.post(`${G_API}events/EVENT_LIST`, {
            page: page,
            limit: PAGE_LIMIT,
        })
        .then((response) => {
            const items = response.data.DATAS || [];
            const current = response.data.CURRENT_PAGE || 1;
            const last = response.data.LAST_PAGE || 1;

            setItems(items);
            setCurrentPage(current);
            setLastPage(last);
            setLoadingItem(false);
        })
        .catch((error) => {
            console.error("Error fetching events:", error);
        });
    };

    useEffect(() => {
        fetchEvents(currentPage);
    }, [currentPage]);

    return (
        <>
            <div id="header-carousel" className="carousel slide" data-bs-ride="carousel" >
                <div className="carousel-inner" >
                    <PageSlider inputType="event" />
                </div>
            </div>
            <section id="event">
                <div className="container-xxl my-5 py-5">
                    <div className="container py-5">
                        <div className="row g-4 justify-content-center list">
                        {loadingItem ? (
                            <div className="text-center my-4">
                                <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : (
                                <div className="item">
                                    {items.map(item => (
                                        <AllEvents key={item.id} item={item}  style={{
                                        width: "calc(33.33% - 20px)",
                                        margin: "20px",
                                        textAlign: "center"
                                        }}/>
                                    ))}
                                </div>
                        )}
                        </div>

                        {/* Pagination */}
                        { !loadingItem && items.length > 0 && (
                            <div className="d-flex justify-content-center mt-4">
                                <nav>
                                    <ul className="pagination">
                                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                            <button className="page-link" onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}>
                                                Previous
                                            </button>
                                        </li>

                                        {Array.from({ length: lastPage }, (_, i) => i + 1).map(page => (
                                            <li key={page} className={`page-item ${page === currentPage ? "active" : ""}`}>
                                                <button className="page-link" onClick={() => setCurrentPage(page)}>
                                                    {page}
                                                </button>
                                            </li>
                                        ))}

                                        <li className={`page-item ${currentPage === lastPage ? "disabled" : ""}`}>
                                            <button className="page-link" onClick={() => setCurrentPage(prev => Math.min(prev + 1, lastPage))}>
                                                Next
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        )}
                        {/* End pagination */}
                    </div>
                </div>
            </section>
        </>
    );
}

export default EventPage;
